var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18918 33.6899L14.3814 42.8821L5.18918 52.0744C3.26177 54.0018 0 52.618 0 49.9493V35.8644C0 33.0969 3.31119 31.7625 5.18918 33.6899Z",
    fill: "url(#paint0_linear_304_251)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4303 42.882L24.4627 29.3408C28.8612 23.4103 37.5098 22.7678 42.7484 27.957L50.8534 36.062C54.6093 39.818 54.6093 45.9461 50.8534 49.7021L42.7484 57.8071C37.5098 63.0457 28.8612 62.4032 24.4627 56.4233L14.4303 42.882Z",
    fill: "url(#paint1_linear_304_251)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0403 33.0967C29.636 33.0967 25.255 37.4777 25.255 42.882C25.255 48.2862 29.636 52.6673 35.0403 52.6673C40.4445 52.6673 44.8256 48.2862 44.8256 42.882C44.8256 37.4777 40.4445 33.0967 35.0403 33.0967Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0406 36.5067C31.5197 36.5067 28.6654 39.361 28.6654 42.882C28.6654 46.4029 31.5197 49.2572 35.0406 49.2572C38.5616 49.2572 41.4159 46.4029 41.4159 42.882C41.4159 39.361 38.5616 36.5067 35.0406 36.5067Z",
    fill: "#2B2B2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5959 36.5068C53.9681 36.5068 55.8461 38.4342 55.8461 40.757V44.9578C55.8461 47.33 53.9187 49.208 51.5959 49.208C49.2237 49.208 47.3458 47.2806 47.3458 44.9578V40.757C47.2963 38.4342 49.2237 36.5068 51.5959 36.5068Z",
    fill: "#F48B94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0785 41.0535H53.7704C54.7588 41.0535 55.599 41.8442 55.599 42.882C55.599 43.9199 54.8083 44.7106 53.7704 44.7106H53.0785C52.0901 44.7106 51.25 43.9199 51.25 42.882C51.25 41.8442 52.0901 41.0535 53.0785 41.0535Z",
    fill: "#2B2B2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4444 200H46.0089C46.0089 176.449 54.2621 165.192 64.7887 150.923C75.513 136.357 91.9207 118.385 98.889 83.3298C99.7291 79.1824 96.9616 75.2325 92.8102 74.5413C88.8566 73.8994 85.15 76.5162 84.3593 80.4167C78.0335 112.263 66.4196 128.062 56.0907 142.134C44.9216 157.242 34.4444 171.561 34.4444 200Z",
    fill: "url(#paint2_linear_304_251)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0067 200.54H75.5858C75.5858 184.38 100.098 163.277 133.704 141.927C138.251 139.012 139.684 133.032 136.917 128.386C134.05 123.543 127.725 122.06 122.931 125.075C109.291 133.724 97.7262 142.471 88.3857 151.169C70.2484 168.12 61.0067 184.726 61.0067 200.54Z",
    fill: "url(#paint3_linear_304_251)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.465 200H200C200 185.706 191.239 167.654 181.992 148.513C174.643 133.329 167.099 117.651 164.47 104.841C163.74 101.181 160.479 98.6583 156.829 98.9056C152.4 99.2024 149.236 103.406 150.161 107.808C153.179 122.547 164.178 139.017 171.917 155.042C180.045 171.808 188.465 189.168 188.465 200Z",
    fill: "url(#paint4_linear_304_251)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0378135 194.314C0.334337 192.101 2.36058 190.591 4.48567 190.893L8.24165 191.446L5.12814 189.182C3.34899 187.874 2.95363 185.409 4.18915 183.597C5.47408 181.786 7.8957 181.384 9.67484 182.641L12.7883 184.906L11.0586 181.434C10.0702 179.472 10.8115 177.057 12.7389 176.05C14.6663 175.044 17.0385 175.799 18.0269 177.761L19.7567 181.233V177.358C19.7567 175.145 21.5358 173.333 23.7103 173.333C25.8848 173.333 27.664 175.145 27.664 177.358V181.233L29.3937 177.761C30.3821 175.799 32.7543 175.044 34.6817 176.05C36.6091 177.057 37.3504 179.472 36.362 181.434L34.6323 184.906L37.7458 182.641C39.5249 181.333 41.996 181.786 43.2315 183.597C44.5164 185.409 44.0716 187.924 42.2925 189.182L39.179 191.446L42.9349 190.893C45.1095 190.591 47.0863 192.101 47.3828 194.314C47.6793 196.528 46.1967 198.541 44.0222 198.843L36.5597 199.95V200H36.2137C36.1149 200 36.0161 200 35.9172 200C35.8184 200 35.7195 200 35.6207 200H11.6517C11.5528 200 11.454 200 11.3551 200C11.2563 200 11.1575 200 11.0586 200H10.4162C10.4162 199.95 10.4162 199.95 10.4162 199.899L3.25016 198.843C1.22391 198.541 -0.258711 196.528 0.0378135 194.314Z",
    fill: "url(#paint5_linear_304_251)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.551 191.506C96.0452 188.198 99.0599 185.926 102.371 186.37L108.153 187.21L103.409 183.802C100.691 181.877 100.048 178.123 101.976 175.407C103.903 172.691 107.659 172.049 110.377 173.975L115.122 177.383L112.453 172.198C110.921 169.235 112.107 165.58 115.072 164.049C118.037 162.519 121.695 163.704 123.227 166.667L125.895 171.852V166.025C125.895 162.716 128.613 160 131.925 160C135.236 160 137.954 162.716 137.954 166.025V171.852L140.623 166.667C142.155 163.704 145.812 162.519 148.777 164.049C151.742 165.58 152.879 169.235 151.396 172.198L148.728 177.383L153.472 173.975C156.19 172.049 159.946 172.691 161.874 175.407C163.801 178.123 163.158 181.877 160.44 183.802L155.696 187.21L161.478 186.37C164.789 185.877 167.853 188.198 168.298 191.506C168.743 194.815 166.47 197.877 163.158 198.321L151.693 199.951V200H151.149C151.001 200 150.853 200 150.655 200C150.507 200 150.358 200 150.21 200H113.441C113.293 200 113.145 200 112.996 200C112.848 200 112.7 200 112.502 200H111.514C111.514 199.951 111.514 199.901 111.514 199.852L100.493 198.272C97.3796 197.827 95.0568 194.815 95.551 191.506Z",
    fill: "url(#paint6_linear_304_251)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.688 19.4628C165.136 19.4628 168.744 15.8551 168.744 11.4072C168.744 6.95939 165.136 3.35168 160.688 3.35168C156.24 3.35168 152.633 6.95939 152.633 11.4072C152.633 15.8551 156.24 19.4628 160.688 19.4628ZM160.688 4.83431C164.296 4.83431 167.261 7.79954 167.261 11.4072C167.261 15.015 164.296 17.9802 160.688 17.9802C157.081 17.9802 154.115 15.015 154.115 11.4072C154.115 7.79954 157.081 4.83431 160.688 4.83431Z",
    fill: "#95B6FC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.444 43.4318C149.964 43.4318 152.04 41.3561 152.04 38.8357C152.04 36.3152 149.964 34.2395 147.444 34.2395C144.923 34.2395 142.847 36.3152 142.847 38.8357C142.847 41.3561 144.923 43.4318 147.444 43.4318ZM147.444 35.7221C149.173 35.7221 150.557 37.1059 150.557 38.8357C150.557 40.5654 149.173 41.9492 147.444 41.9492C145.714 41.9492 144.33 40.5654 144.33 38.8357C144.33 37.1059 145.714 35.7221 147.444 35.7221Z",
    fill: "#95B6FC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.933 91.3205L163.209 80.5962L173.933 69.8719C176.157 67.648 180.012 69.2294 180.012 72.3924V88.8C180.012 91.963 176.157 93.5444 173.933 91.3205Z",
    fill: "url(#paint7_linear_304_251)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.209 80.5963L151.546 96.4109C146.406 103.33 136.324 104.12 130.196 97.9923L120.707 88.5036C116.309 84.1051 116.309 76.9886 120.707 72.5901L130.196 63.1014C136.275 57.0226 146.406 57.7639 151.546 64.6828L163.209 80.5963Z",
    fill: "url(#paint8_linear_304_251)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.141 92.0124C132.836 92.0124 127.725 86.9012 127.725 80.5962C127.725 74.2913 132.836 69.1801 139.141 69.1801C145.446 69.1801 150.557 74.2913 150.557 80.5962C150.557 86.9012 145.446 92.0124 139.141 92.0124Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.14 88.0093C135.046 88.0093 131.727 84.6903 131.727 80.5962C131.727 76.5021 135.046 73.1831 139.14 73.1831C143.234 73.1831 146.553 76.5021 146.553 80.5962C146.553 84.6903 143.234 88.0093 139.14 88.0093Z",
    fill: "#2B2B2B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.817 88.0094C117.05 88.0094 114.826 85.7855 114.826 83.0179V78.1253C114.826 75.3577 117.05 73.1338 119.817 73.1338C122.585 73.1338 124.809 75.3577 124.809 78.1253V83.0179C124.809 85.7855 122.585 88.0094 119.817 88.0094Z",
    fill: "#F48B94"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.296 82.7214H118.087C119.273 82.7214 120.212 81.7824 120.212 80.5963C120.212 79.4102 119.273 78.4712 118.087 78.4712H117.296C116.11 78.4712 115.171 79.4102 115.171 80.5963C115.171 81.7824 116.11 82.7214 117.296 82.7214Z",
    fill: "#2B2B2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_251",
    x1: 14.4099,
    y1: 42.8778,
    x2: 0.0284933,
    y2: 42.8778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4092,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4989,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_304_251",
    x1: 53.6705,
    y1: 42.9005,
    x2: 14.4305,
    y2: 42.9005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4092,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4989,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_304_251",
    x1: 99.0393,
    y1: 137.222,
    x2: 34.4444,
    y2: 137.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_304_251",
    x1: 99.6661,
    y1: 127.842,
    x2: 99.6661,
    y2: 196.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBCBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CBCBA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_304_251",
    x1: 175,
    y1: 149.008,
    x2: 175,
    y2: 195.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_304_251",
    x1: 23.7104,
    y1: 178.288,
    x2: 23.7104,
    y2: 199.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_304_251",
    x1: 131.919,
    y1: 162.914,
    x2: 131.919,
    y2: 198.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48B94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A9A6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_304_251",
    x1: 163.209,
    y1: 80.5962,
    x2: 180.012,
    y2: 80.5962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_304_251",
    x1: 117.409,
    y1: 80.5569,
    x2: 163.209,
    y2: 80.5569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.b412a49f.svg";
export { ForwardRef as ReactComponent };